// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1_Vra","dragIcon":"SortableItem_dragIcon__iyKvV","disabled":"SortableItem_disabled__2N8u2"};